export const isActionEnabled = (enable) => enable === 1 || enable === true || enable === '1';

export const buildGetExportSettingsPayload = (exportId, caseid) => ({
  command: 'getExportSettings',
  export_id: exportId,
  caseid
});
